import PropTypes from 'prop-types';
import React from 'react';
import { Transition, config } from 'react-spring';

import Theme from 'styles/theme';

const Fade = ({ show, children, ...otherProps }) => (
  <Transition
    config={{
      ...config.stiff,
      restSpeedThreshold: 0.2,
      restDisplacementThreshold: 0.2,
      duration: Theme.get('transition-duration') / 2,
    }}
    from={{ opacity: 0 }}
    enter={{ opacity: 1 }}
    leave={{ opacity: 0 }}
    {...otherProps}
  >
    {show &&
      (styles => (
        <div className="Fade" style={styles}>
          {children}
        </div>
      ))}
  </Transition>
);

Fade.propTypes = {
  show: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

Fade.defaultProps = {
  show: true,
  children: null,
};

export default Fade;
